import GentleProxy from "../common/proxy";

const SVC = () => {
    console.log("SVC");
}

SVC.account = function() {
    console.log("SVC_account");

    const onSuccess = (data) => {
        console.log("SVC.Session >", data.headers);
    }

    const onFailed = (data) => {
        console.log("SVC.Session connction Failed > ", data);
    }

    const proxy = Object.create(GentleProxy);
    // proxy.request("svc_session", "", onSuccess, onFailed);
    proxy.request("access_token", "", onSuccess, onFailed);
};

export default SVC;